import React, { useState } from 'react';
import '../styles/ModeSelector.css';

interface Props {
  currentMode: string;
  onModeChange: (mode: string) => void;
}

const MODES = [
  { id: 'GOVERNANCE', label: 'Governance', emoji: '🎯', role: 'Chief of Staff' },
  { id: 'CAPITAL', label: 'Capital', emoji: '💰', role: 'CFO (MONETA)' },
  { id: 'LEGAL', label: 'Legal', emoji: '⚖️', role: 'General Counsel (FIDIUS)' },
  { id: 'TECHNOLOGY', label: 'Technology', emoji: '⚙️', role: 'CTO (VULCAN)' },
  { id: 'BRAND', label: 'Brand', emoji: '🎨', role: 'Chief Brand (VENUS)' },
  { id: 'OPERATIONS', label: 'Operations', emoji: '📋', role: 'COO (OPERA)' },
  { id: 'MARKETING', label: 'Marketing', emoji: '📢', role: 'CMO (MERCURY)' },
  { id: 'GROWTH', label: 'Growth', emoji: '📈', role: 'Chief Growth (FAUNUS)' },
  { id: 'PARTNERSHIPS', label: 'Partnerships', emoji: '🤝', role: 'Chief Partnerships (JANUS)' },
  { id: 'CUSTOMER', label: 'Customer', emoji: '❤️', role: 'Chief Customer (VESTA)' },
  { id: 'AUDIT', label: 'Audit', emoji: '🔍', role: 'Auditor (CUSTOS)' },
  { id: 'REALWORLD', label: 'Real World', emoji: '🌍', role: 'Real-World Ops (CURA)' },
  { id: 'TIMING', label: 'Timing', emoji: '⏱️', role: 'Timing Adviser (KAIROS)' },
  { id: 'AIINFRA', label: 'AI Infra', emoji: '🧠', role: 'AI Infra Adviser (NESTOR)' },
];

export default function ModeSelector({ currentMode, onModeChange }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const currentModeObj = MODES.find(m => m.id === currentMode);

  const handleModeSelect = (modeId: string) => {
    onModeChange(modeId);
    setIsOpen(false);
  };

  return (
    <div className="mode-selector">
      <button
        className="mode-button"
        onClick={() => setIsOpen(!isOpen)}
        title="Switch mode"
      >
        <span className="mode-emoji">
          {currentModeObj?.emoji || '🧠'}
        </span>
        <div className="mode-info">
          <div className="mode-label">{currentModeObj?.label || 'Unknown'}</div>
          <div className="mode-role">{currentModeObj?.role || ''}</div>
        </div>
        <span className="mode-dropdown-icon">▼</span>
      </button>

      {isOpen && (
        <div className="mode-menu">
          <div className="mode-menu-header">Switch to mode...</div>
          <div className="mode-list">
            {MODES.map(mode => (
              <button
                key={mode.id}
                onClick={() => handleModeSelect(mode.id)}
                className={`mode-option ${currentMode === mode.id ? 'active' : ''}`}
              >
                <span className="mode-option-emoji">{mode.emoji}</span>
                <div className="mode-option-text">
                  <div className="mode-option-label">{mode.label}</div>
                  <div className="mode-option-role">{mode.role}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
